module.exports = __webpack_public_path__ + "img/portrait_640.0aec2189.jpg";